import React, { FC, useState } from 'react'
import { Select, SelectProps } from 'antd'
import { energyUnits } from '../../constants'

function mapToOptions(unit: string) {
  return { label: unit, value: unit }
}
const energyUnitOptions = energyUnits.map(mapToOptions)

interface Props extends SelectProps {
  units?: string[]
}

const RSelectUnits: FC<Props> = ({ units, ...props }) => {
  const [options] = useState(units ? units.map(mapToOptions) : energyUnitOptions)

  return <Select options={options} {...props} defaultValue={options[0].value} />
}

export default RSelectUnits
